import { computed, defineComponent, onMounted, ref, watch, getCurrentInstance } from "vue";
export default defineComponent({
    props: {
        size: String,
        multiple: {
            type: Boolean,
            default: true
        },
        collapseTags: {
            type: Boolean,
            default: true
        },
        disabled: Boolean,
        selected: {
            required: true
        },
        placeholder: String,
        name: String,
        id: String,
        clearable: {
            type: Boolean,
            default: true
        },
        visible: Boolean
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var inputWidth = ref(0);
        var fakeSelect = ref();
        var fakeTags = ref();
        var selectedLabel = ref();
        var inputHovering = ref(false);
        var selectWidth = ref(0);
        var selectSize = computed(function() {
            // @ts-ignore
            return props.size || (root.$ELEMENT || {}).size;
        });
        var collapseTagSize = computed(function() {
            return [
                "small",
                "mini"
            ].indexOf(selectSize.value) > -1 ? "mini" : "small";
        });
        var selectDisabled = computed(function() {
            return props.disabled;
        });
        var deleteTag = function(event, tag) {
            emit("remove-tag", tag.value);
            event.stopPropagation();
        };
        var handleClearClick = function(event) {
            emit("clear");
            event.stopPropagation();
        };
        var showClose = computed(function() {
            var hasValue = props.multiple ? Array.isArray(props.selected) && props.selected.length > 0 : props.selected !== undefined && props.selected !== null && props.selected !== "";
            var criteria = props.clearable && !selectDisabled.value && inputHovering.value && hasValue;
            return criteria;
        });
        var iconClass = computed(function() {
            return props.visible ? "arrow-up is-reverse" : "arrow-up";
        });
        watch(function() {
            return props.selected;
        }, function(val) {
            if (val.length) {
                root.$nextTick(function() {
                    if (fakeTags && fakeTags.value) {
                        selectWidth.value = fakeTags.value.getBoundingClientRect().width;
                    }
                });
            } else {
                selectWidth.value = 0;
            }
        }, {
            immediate: true
        });
        onMounted(function() {
            root.$nextTick(function() {
                if (fakeSelect && fakeSelect.value) {
                    inputWidth.value = fakeSelect.value.getBoundingClientRect().width;
                }
                if (fakeTags && fakeTags.value) {
                    selectWidth.value = fakeTags.value.getBoundingClientRect().width;
                }
            });
        });
        return {
            fakeSelect: fakeSelect,
            selectSize: selectSize,
            collapseTagSize: collapseTagSize,
            inputWidth: inputWidth,
            selectDisabled: selectDisabled,
            deleteTag: deleteTag,
            selectedLabel: selectedLabel,
            inputHovering: inputHovering,
            showClose: showClose,
            iconClass: iconClass,
            handleClearClick: handleClearClick,
            selectWidth: selectWidth,
            fakeTags: fakeTags
        };
    }
});
